module.exports = __webpack_public_path__ + "static/media/topless_jeff.b7d30ccf.jpg";